var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationIcon4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66634 2.33333H2.99967C2.0792 2.33333 1.33301 3.07953 1.33301 4V14C1.33301 14.9205 2.0792 15.6667 2.99967 15.6667H12.9997C13.9201 15.6667 14.6663 14.9205 14.6663 14V4C14.6663 3.07953 13.9201 2.33333 12.9997 2.33333H11.333M7.99967 1.5V8.16667M7.99967 8.16667L10.4997 5.66667M7.99967 8.16667L5.49967 5.66667M1.33301 9.83333H3.48783C3.70884 9.83333 3.92081 9.92113 4.07709 10.0774L6.08893 12.0893C6.24521 12.2455 6.45717 12.3333 6.67819 12.3333H9.32116C9.54218 12.3333 9.75414 12.2455 9.91042 12.0893L11.9223 10.0774C12.0785 9.92113 12.2905 9.83333 12.5115 9.83333H14.6663",
    stroke: "#eaa827",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationIcon4);
export default __webpack_public_path__ + "static/media/application-icon-4.12f8372ead00a4c19c2a7d91c6b1c1e1.svg";
export { ForwardRef as ReactComponent };